module.exports = __webpack_public_path__ + "68b6ac0f289e68243f74b348aaafd644.svg";